var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindTurbine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.555,56.638c-3.257-2.562-6.582-5.03-9.987-7.382c-2.887-2.358-5.896-4.226-9.587-4.787 c0.139-0.469,0.237-0.956,0.237-1.47c0-2.477-1.739-4.547-4.057-5.077c0.521-1.437,0.794-2.874,0.976-4.31 c0.3-2.057-0.233-4.113-0.4-6.17c-0.335-4.125-0.81-8.238-1.4-12.34c-0.027-0.225-0.372-0.219-0.4,0 c-0.59,4.102-1.065,8.215-1.4,12.34c-0.584,3.586-0.696,7.039,0.558,10.431c-2.445,0.432-4.312,2.56-4.312,5.126 c0,0.516,0.099,1.006,0.239,1.477c-1.593,0.257-3.045,0.76-4.446,1.348c-1.931,0.768-3.446,2.258-5.143,3.431 c-3.405,2.352-6.73,4.821-9.987,7.382c-0.181,0.136-0.004,0.431,0.2,0.346c3.847-1.54,7.647-3.185,11.387-4.958 c3.454-1.309,6.549-2.966,8.873-5.834c0.41,0.524,0.912,0.964,1.49,1.3l-1.21,30.323c-0.021,0.544,0.179,1.073,0.557,1.466 c0.377,0.393,0.897,0.614,1.442,0.614h3.633c0.544,0,1.065-0.222,1.442-0.614s0.578-0.922,0.556-1.466l-1.21-30.323 c0.58-0.338,1.085-0.78,1.496-1.307c1.004,1.215,2.139,2.202,3.324,3.102c1.631,1.288,3.679,1.855,5.543,2.739 c3.739,1.772,7.54,3.418,11.387,4.958C72.563,57.073,72.731,56.772,72.555,56.638z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindTurbine);
export default __webpack_public_path__ + "static/media/wind-turbine.51316b710bad15978de283d3db6aa743.svg";
export { ForwardRef as ReactComponent };